/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listUsers = /* GraphQL */ `
  query ListUsers($limit: Int, $paginationToken: String) {
    listUsers(limit: $limit, paginationToken: $paginationToken) {
      users {
        username
        email
        name
        phoneNumber
        emailVerified
        enabled
        status
        created
        modified
        groups
        __typename
      }
      paginationToken
      __typename
    }
  }
`;
export const getUserAppSettings = /* GraphQL */ `
  query GetUserAppSettings($id: String!) {
    getUserAppSettings(id: $id) {
      id
      email
      approvalStatus
      savedQueries {
        queryID
        name
        tags
        description
        queryData
        isShareable
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserAppSettings = /* GraphQL */ `
  query ListUserAppSettings(
    $id: String
    $filter: ModelUserAppSettingsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserAppSettings(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        email
        approvalStatus
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
